import {
  Box as MuiBox,
  Button as MuiButton,
  styled as muiStyled,
} from "@mui/material";

const Box = muiStyled(MuiBox)`
  &.button-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 260px;
    font-size: 40px;

    &.small-text {
      font-size: 30px;
    }
  }
`;

const CustomButton = muiStyled(MuiButton)(
  ({ theme }) => `
  height: 120px;
  
  &.Mui-disabled {
    color: #bbbbbb;
    background: #f1f1f1;
    border: solid 1px #dee2ec;
  }
  
  
  
  &.regular {
    border-color: #F1F1F1;
    color: black;
    font-size: 3vw;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    padding: 2%;
    width: 100%;

    &.selected {
      background: #f3f8ff;
      color: ${theme.palette.primary.main};
      border: solid 1px ${theme.palette.primary.main};
    }
  }
`
);

interface DialButtonProps {
  text: string;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
}

export const DialButton = ({
  text,
  onClick,
  selected,
  disabled,
}: DialButtonProps) => {
  return (
    <CustomButton
      onClick={onClick}
      variant="outlined"
      disabled={disabled}
      className={`regular ${selected ? "selected" : ""}`}
    >
      <Box className={`button-text ${text.length > 6 ? "small-text" : ""}`}>
        {text}
      </Box>
    </CustomButton>
  );
};
